<template>

    <main class="topic">

        <div class="topic-inner" v-if="isLoaded">
        </div>

        <!--<teaser
                class="teaser-white-pink"
                :teaser-filter-params="teaserFilterParams"
                :teaser-max-items="8"
        ></teaser>

        <features
                :features-filter-params="featuresFilterParams"
                features-heading="Features"
        ></features>-->
        <tabbed-teaser :teaser-filter-params="teaserFilterParams" :show-categories-filter-param="false"></tabbed-teaser>

    </main>

</template>

<script>

    // console.log('Topic');

    import env from '../env';

    import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

    //import Features from './Features.vue';
    //import Teaser from './Teaser.vue';
    import TabbedTeaser from './TabbedTeaser.vue';

    export default {
        mixins : [smoothReflow],
        created(){
            console.log(this.$route.params['tag']);
            this.teaserFilterParams['filter[primary_keyword]'] = [this.$route.params['tag']];
            this.title = `Thema: ${this.$route.params['tag']}`;
        },
        destroyed(){
        },
        mounted(){
            this.$smoothReflow({
                transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
            });
            window.setTimeout(()=>{
                // this.$ga.page(this.$route.fullPath);
                this.$gtm.trackEvent({
                    event : 'Pageview',
                    url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                });
            });
        },
        components : {
            //Features,
            TabbedTeaser,
        },
        data(){
            return {
                featuresFilterParams : {
                    seriesKeywords : [env.SERIES_KEYWORD_ID_FEATURE],
                },
                isLoaded : false,
                //teaserFilterParams : {},
                title : 'Thema',
            };
        },
        props : {
            'teaserFilterParams' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
        },
        metaInfo(){
            return {
                title : this.title,
            };
        },
        methods : {},
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .topic {
        padding: 5.5rem 0 0 0;
        @media screen and (min-width: 1200px) {
            padding: 5.5rem * $factor-1200 0 0 0;
        }
        @media screen and (min-width: 1440px) {
            padding: 5.5rem * $factor-1440 0 0 0;
        }
        @media screen and (min-width: 1920px) {
            padding: 5.5rem * $factor-1920 0 0 0;
        }
        @media screen and (min-width: 2400px) {
            padding: 5.5rem * $factor-2400 0 0 0;
        }
    }

</style>



// WEBPACK FOOTER //
// public/js/components/Topic.vue